<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Vendas por Produto</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input type="datetime-local" label="Data Início" placeholder="Digite aqui" name="DT_INIC"
              formControlName="DT_INIC" width="100%"></app-input>
            <app-input type="datetime-local" label="Data Final" placeholder="Digite aqui" name="DT_FIM"
              formControlName="DT_FIM" width="100%"></app-input>
          </form>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
      </div>

      <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">
          Quantidade Total: {{ quantidadeTotalFormatada }}
        </h2>
        <h2 class="valor">
          Valor Total: {{ valorTotalFormatado }}
        </h2>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input type="datetime-local" label="Data Início" placeholder="Digite aqui" name="DT_INIC"
        formControlName="DT_INIC" width="100%"></app-input>
      <app-input type="datetime-local" label="Data Final" placeholder="Digite aqui" name="DT_FIM"
        formControlName="DT_FIM" width="100%"></app-input>
    </form>

    <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="true"></app-card>

    <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
      <h2 class="valor">Quantidade Total: {{ quantidadeTotalFormatada }}</h2>
      <h2 class="valor">Valor Total: {{ valorTotalFormatado }}</h2>
    </div>
  </div>

  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
